module.exports = __webpack_public_path__ + "static/urszula-piekarska-aae740158add2fa945ea96feabcc6f73.jpg";